import { useTranslate } from '@tolgee/react';

import { Icon } from '../Icon';

type RequiredFieldBannerProps = {
  label?: string;
};

export function RequiredFieldBanner({ label }: RequiredFieldBannerProps) {
  const { t } = useTranslate();
  return (
    <div className="flex w-full items-center justify-center gap-4 rounded border border-[#72080A] bg-[#FFE3D6] px-4 py-3 text-center text-[#72080A]">
      <Icon icon="alert" isCustom />
      {label || t('common.ticket_required_field_banner')}
    </div>
  );
}
